import { categoriseAmount, constDate, once, repeat, scaleAmount, unit, } from '../payments/constructors.js';
import { recurrenceFor } from '../payments/dsl.js';
import { firstDueDate } from '../payments/recipes.js';
export function oneTimeTerm(taxonomy, description, amount, due) {
    return once(constDate(due), categoriseAmount(taxonomy, description, scaleAmount(amount, unit())));
}
export function monthlyTerm(taxonomy, description, amount, dayOfMonth, start, end) {
    const first = firstDueDate(start, dayOfMonth);
    return repeat(recurrenceFor('monthly', 1, first), categoriseAmount(taxonomy, description, scaleAmount(amount, unit())), 'USD', first, end);
}
//# sourceMappingURL=expenseTerm.js.map